import React from "react";
import "./App.css";
import "leaflet/dist/leaflet.css";

function App() {
    return <div className="App"></div>;
}

export default App;
